import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import './global.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { datadogRum } from '@datadog/browser-rum';
import { userSignOut } from './services/auth.service';


// Initialize Datadog RUM
datadogRum.init({
  applicationId: import.meta.env.VITE_DATADOG_RUM_APP_ID || '',
  clientToken: import.meta.env.VITE_DATADOG_RUM_CLIENT_TOKEN || '',
  // `site` refers to the Datadog site parameter of your organization
  // see https://docs.datadoghq.com/getting_started/site/
  site: import.meta.env.VITE_DATADOG_SITE || '',
  service: import.meta.env.VITE_DATADOG_SERVICE_NAME || '',
  env: import.meta.env.VITE_DATADOG_ENV || '',
  // Specify a version number to identify the deployed version of your application in Datadog
  // version: '1.0.0',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input',
  startSessionReplayRecordingManually : true
});

// Sign out and redirect to login if any API returns 403 accountFlagged mid-session
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error?.response?.status === 403 &&
      error?.response?.data?.accountFlagged === true
    ) {
      userSignOut();
      window.location.href = '/login?reason=flagged';
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
